import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    marginTop: theme.spacing(4),
    backgroundColor: theme.colors.notice_background,
    '&> div': {
      borderTop: `1px solid ${theme.colorPalette.beige_25_op_30} `
    },
    '&> div:first-child': {
      borderTop: 'none'
    },
    marginBottom: theme.spacing(4),
    paddingTop: 15,
    paddingBottom: 15,
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8)
  },
  altContainer: {
    width: '100%',
    marginTop: theme.spacing(4),
    backgroundColor: theme.colorPalette.green_80,
    '&> div': {
      borderTop: `1px solid ${theme.colorPalette.beige_25_op_30} `
    },
    '&> div:first-child': {
      borderTop: 'none'
    },
    marginBottom: theme.spacing(4),
    padding: 15,
    color: theme.colorPalette.beige_50
  },
  icon: {
    marginRight: theme.spacing(4),
    width: 50,
    height: 30,
    color: theme.colorPalette.white
  },
  styledText: {
    display: 'block',
    lineHeight: 1.3
  },
  button: {
    ...reskinStyles(theme, {
      '&&': { backgroundColor: theme.colorPalette.green_100, color: theme.colorPalette.white },
      '&&:hover': { backgroundColor: theme.colorPalette.green_90, color: theme.colorPalette.white }
    }),
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colorPalette.white
  }
}));

export default useStyles;
